// v2 endpoint registry. Mounted under the `api/v2` node in ./base.js.
// Same declarative shape as ./list.js: { name, url, method } leaves, nested `url` groups.
const listsV2 = [
  { name: "getDeliveries", url: "deliveries", method: "GET" },
  {
    url: "admin",
    children: [{ name: "getDeliveriesAdmin", url: "deliveries", method: "GET" }],
  },
  {
    url: "reports",
    children: [
      { name: "getMostEmailSummaryV2", url: "reports-most", method: "GET" },
      {
        name: "getLineEmailReportsV2",
        url: "email-reports-perday",
        method: "GET",
      },
      {
        name: "getChartReportV2",
        url: "count-email-delivery",
        method: "GET",
      },
      { name: "getEmailSendingSummaryV2", url: "email-summary", method: "GET" },
      { name: "getTableReportV2", url: "daily-email-delivery/all", method: "GET" },
    ],
  },
];

export default listsV2;
